import { axiosInstance } from "../axios-instance";


const users = "users";
const usersServices = {
  getUsers: () => axiosInstance.get(`/${users}`),
  getUser: (id) => axiosInstance.get(`/${users}/${id}`),
  storeUser: (payload) =>
    axiosInstance.postForm(`/${users}`, payload),
  updateUser: (payload) =>
    axiosInstance.post(`/${users}/${payload.id}`, payload),
  DeleteUser: (id) => axiosInstance.delete(`/${users}/${id}`),
};
export default usersServices;
